import React, {Component} from 'react';
import './FormExportPage.css';
import Page from '../../components/page/Page'
import UpdateTitle from "../../components/updateTitle/UpdateTitle";
import FilterInput from "../../inputs/filterInput/FilterInput";
import Card from "../../components/card/Card";
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import formFilters from "../../utils/formFilters";
import models from '../../model/models';
import DrugConcentrationPopup from '../../popups/drugConcentrationPopup/DrugConcentrationPopup';

export default class FormExportPage extends Component {
	constructor(props) {
		super(props);
		const defaultFilter = formFilters.defaultFilter(this.props.match.params.id);
		this.state = {
			drugTypes: [],
			concentrations: {},
			filter: this._getFilterValue(defaultFilter)
		};
	}

	_getFilterValue = (currentFilter) => {
		if (!currentFilter || !Array.isArray(currentFilter)) return null;
		const value = {};
		for (let i in currentFilter) {
			const column = currentFilter[i].column;
			if (!value[column]) value[column] = { values: [] };
			value[column].values.push(currentFilter[i].value);
		}
		return value;
	}

	componentDidMount = () => {
		this.typeSubId = models.drug_type.onChange(this._updateDrugTypes);
		this._updateDrugTypes();
	};

	componentWillUnmount = () => {
		models.drug_type.unsubscribe(this.typeSubId);
	};

	_updateDrugTypes = () => {
		const allowedTypes = models.drug_type.allowed();
		const drugTypes = Object.values(allowedTypes);
		this.setState({ drugTypes });
	};

	_handleFilterChange = (filter) => {
		for (let i in filter){
		  for (let j in filter[i].values) {
				if(filter[i].values[j].datetime && filter[i].values[j].datetime.toISOString){
					filter[i].values[j].datetime = filter[i].values[j].datetime.toISOString();
				}
			}
		}
		this.setState({ filter });
	};

	_onConcentrationComplete = (concentrations) => {
		this.setState({ concentrations }, () => {
			this._download();
		});
	};

	_download = () => {
		const { filter } = this.state;
		const queryParams = new URLSearchParams();
		
		let startDate = null;
		let endDate = null;
		
		if (filter && filter.created_on && filter.created_on.values) {
			filter.created_on.values.forEach((value) => {
				if (value.operator === '>') {
					startDate = value.datetime;
				} else if (value.operator === '<') {
					endDate = value.datetime;
				}
			});
		}
		
		if (startDate) {
			queryParams.append('startDate', startDate);
		}
		if (endDate) {
			queryParams.append('endDate', endDate);
		}

		
		const url = `/api/v1/form/Ny3848${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
		
		fetch(url, {
			method: 'GET',
			headers: {
				'x-auth-token': localStorage.token,
				'user-group-id': localStorage.user_group_id || '',
				'x-user-group-id': localStorage.user_group_id || '',
				'x-region': localStorage.region || '',
				'x-admin-version': (localStorage['x-admin-version'] || ''),
				'last-log-in': localStorage.last_log_in || '',
			},
		})
			.then(response => {
				if (!response.ok) throw new Error('Network response was not ok');
				return response.blob();
			})
			.then(blob => {
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'NY3848.pdf');
				document.body.appendChild(link);
				link.click();
				link.parentNode.removeChild(link);
				window.URL.revokeObjectURL(url);
			})
			.catch(error => {
				console.error('Error downloading NY3848 PDF:', error);
			});
	};

	download = () => {
		window.popupController.show(DrugConcentrationPopup, {
			drugTypes: this.state.drugTypes,
			onComplete: this._onConcentrationComplete
		});
	};

	render() {
		const startDate = new Date();
		startDate.setMonth(0);
		return (
			<Page className="g-form-export-page">
				<UpdateTitle newTitle="Form Export" originalTitle="LogRx"/>
				<Card>
					<FilterInput
						onChange={this._handleFilterChange}
						currentFilter={formFilters.defaultFilter(this.props.match.params.id)}
						options={formFilters.options(this.props.match.params.id)}
					/>
					<PrimaryButton className={'export'} onClick={this.download}>Download</PrimaryButton>
				</Card>
			</Page>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/formExportPage/FormExportPage.jsx